export default __webpack_public_path__ + "static/media/c4c18b9672ff1824c3f36f021967eefe.svg";